import AdminProductsList from "../features/admin/AdminProductsList";

export default function AdminHomePage() {
  return (
    <>
      <AdminProductsList />
    </>
  );
}
